import { render } from "./ExpressionOfInterestForm.vue?vue&type=template&id=5f10f56c"
import script from "./ExpressionOfInterestForm.vue?vue&type=script&lang=js"
export * from "./ExpressionOfInterestForm.vue?vue&type=script&lang=js"
script.render = render

export default script